import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { GetDefaultYearResponse } from '../models/app.model';

@Injectable({
  providedIn: 'root',
})
export class PeriodService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/defaultyear`;

  getDefaultYear(): Observable<number> {
    return this.http.get<GetDefaultYearResponse>(this.baseUrl).pipe(
      map((d) => d.defaultYear),
      catchError(() => of(new Date().getFullYear())),
    );
  }
}
